module.exports = __webpack_public_path__ + "img/case-ct_compactvanguards.56cc4c8.png";